import { Link } from "react-router-dom";
import { categories } from "@/mocks/movies";

export default function SiteFooter() {
  return (
    <footer className="border-t border-background-200/60 bg-background-100">
      <div className="px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="mb-3 flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-movie-2-line" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">屁屁影院</span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-500">
              聚合最新电影与电视剧资源，为你提供清晰快捷的发现与浏览体验。
            </p>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold text-foreground-950">
              <a href="/#categories" className="hover:text-accent-400">影视分类</a>
            </h4>
            <ul className="space-y-2 text-sm">
              {categories.slice(0, 5).map((c) => (
                <li key={c.key}>
                  <Link to={`/category/${c.key}`} className="text-foreground-500 transition-colors hover:text-accent-400">
                    {c.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold text-foreground-950">
              <a href="/#categories" className="hover:text-accent-400">快捷入口</a>
            </h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-foreground-500 hover:text-accent-400">网站首页</Link></li>
              <li><Link to="/search" className="text-foreground-500 hover:text-accent-400">影视搜索</Link></li>
              <li><Link to="/about" className="text-foreground-500 hover:text-accent-400">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold text-foreground-950">
              <a href="/about" className="hover:text-accent-400">联系我们</a>
            </h4>
            <ul className="space-y-2 text-sm text-foreground-500">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400" />
                <span>hello@pipi-cinema.example.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-accent-400" />
                <span>工作日 9:00 - 18:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200/60 pt-6 text-xs text-foreground-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 屁屁影院 PiPi Cinema. 本站内容均为示范数据，仅用于功能演示。</p>
          <p>播放功能为前端演示，即将支持正式播放。</p>
        </div>
      </div>
    </footer>
  );
}